import apiClient from "../../../../shared/infrastructure/api/client";
import { PublicMeditation, PublicMeditationKind } from "../../domain/types";

interface RawPublicMeditation {
    id: string;
    title: string;
    description: string | null;
    language: string | null;
    declared_duration_seconds: number | null;
    estimated_seconds: number;
    kind: string;
    therapy_types: string[];
    presenting_problems: string[];
    author_name: string | null;
    published_at: string | null;
}

function toDomain(raw: RawPublicMeditation): PublicMeditation {
    return {
        id: raw.id,
        title: raw.title,
        description: raw.description,
        language: raw.language,
        declaredDurationSeconds: raw.declared_duration_seconds,
        estimatedSeconds: raw.estimated_seconds,
        kind: raw.kind as PublicMeditationKind,
        therapyTypes: raw.therapy_types,
        presentingProblems: raw.presenting_problems,
        authorName: raw.author_name,
        publishedAt: raw.published_at,
    };
}

export const PublicMeditationsAPI = {
    list: async (): Promise<PublicMeditation[]> => {
        const { data } = await apiClient.get<RawPublicMeditation[]>(
            "/public/meditations"
        );
        return data.map(toDomain);
    },

    get: async (id: string): Promise<PublicMeditation> => {
        const { data } = await apiClient.get<RawPublicMeditation>(
            `/public/meditations/${id}`
        );
        return toDomain(data);
    },
};
